var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealTimerecommendationtracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 77,
    rx: 15,
    fill: "url(#paint0_linear_329_91)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0007 50.6667C45.444 50.6667 50.6673 45.4434 50.6673 39C50.6673 32.5567 45.444 27.3334 39.0007 27.3334C32.5573 27.3334 27.334 32.5567 27.334 39C27.334 45.4434 32.5573 50.6667 39.0007 50.6667Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34V39L41.5 41.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5168 47.9167L45.9335 54.3C45.8584 55.1311 45.4743 55.9037 44.8571 56.4654C44.24 57.027 43.4346 57.3367 42.6001 57.3333H35.3835C34.549 57.3367 33.7436 57.027 33.1265 56.4654C32.5093 55.9037 32.1252 55.1311 32.0501 54.3L31.4668 47.9167M31.4835 30.0833L32.0668 23.7C32.1416 22.8718 32.5233 22.1015 33.137 21.5402C33.7506 20.979 34.5519 20.6674 35.3835 20.6667H42.6335C43.4679 20.6633 44.2733 20.973 44.8905 21.5346C45.5076 22.0962 45.8917 22.8689 45.9668 23.7L46.5501 30.0833",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_329_91",
    x1: 72,
    y1: 74,
    x2: 5,
    y2: 5.50001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BE7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimerecommendationtracking);
export default __webpack_public_path__ + "static/media/RealTimerecommendationtracking.a5f5e2d049429ca9844671e05774df17.svg";
export { ForwardRef as ReactComponent };